module.exports = __webpack_public_path__ + "img/es.a3966844.png";